import { createAction, ActionType } from 'typesafe-actions';
import { DisplayOptionsType } from 'Common/appshell_types';

const defaultNotificationShowInterval = 3;

export const addNotification = createAction(
    '@NOTIFICATIONS/add',
    action => ({
        message,
        autoHideInterval = defaultNotificationShowInterval,
        isSticky,
        displayType,
        dismissable = true,
    }: {
        message: string;
        autoHideInterval?: number | null;
        isSticky?: boolean;
        dismissable?: boolean;
        displayType?: DisplayOptionsType;
    }) => action({ message, displayType, autoHideInterval, isSticky, dismissable })
);
export const removeNotification = createAction('@NOTIFICATIONS/remove', action => (id: string) => action({ id }));

const actions = { addNotification, removeNotification };

export type NotificationActions = ActionType<typeof actions>;
